import {Pipe, PipeTransform} from '@angular/core';
import {hyphenateHTMLSync} from 'hyphen/de';

@Pipe({
    name: 'lvHyphenationPipe', pure: false,
    standalone: false
})
export class HyphenationPipe implements PipeTransform {

  public transform(value: string): any {
    if (!value) {
      return value;
    }
    return hyphenateHTMLSync(value);
  }
}
